<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="06" :question="question" :comment="comment"></QuestionTitle>
        <div class="container-70 mt-20px">
            <ConsommationEnergetique v-model="result"></ConsommationEnergetique>
            <div v-if="result!=null" @click="saveAndContinue('consommationEnergetiqueData', JSON.stringify(result), '/resultats')"  class="btn-primary d-block w-100 mt-50px text-center">Suivant</div>
            <AvancementLine percent="75%" class="mt-50px"></AvancementLine>
        </div>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import AvancementLine from '@/components/AvancementLine.vue'
import ConsommationEnergetique from '@/components/ConsommationEnergetique.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            question:'Par quel moyen souhaitez-vous calculer les GES émis par les déplacements des conférencier(ère)s et artistes de votre évènement?',
            comment:'Ces informations sont facilement retraçables sur les factures de vos fournisseurs.'
        }
    },
    components: {
        QuestionTitle,
        AvancementLine,
        ConsommationEnergetique
    },
    mixins:[utils],
    mounted(){
        if(sessionStorage.getItem('consommationEnergetiqueData')){
            this.result=JSON.parse(sessionStorage.getItem('consommationEnergetiqueData'))
        }
    }
}
</script>